import { KdsMultiCombobox } from "@kazaar-platform/design-system";
import { Controller, useFormContext } from "react-hook-form";
import { type ControlledMultiComboboxProps } from "./ControlledMultiCombobox.types";

const ControlledMultiCombobox = ({
  name,
  ...inputProps
}: ControlledMultiComboboxProps) => {
  const { control, formState } = useFormContext();
  const error = formState.errors[name];

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <KdsMultiCombobox
          {...inputProps}
          errorMessage={error?.message?.toString()}
          hasError={!!error}
          selectedItems={field.value?.map((id: string) => {
            const item = inputProps.items.find((item) => item.id === id);

            return {
              id: item?.id,
              textValue: item?.textValue,
              label: item?.label,
            };
          })}
          onSelectedItemsChange={(items) =>
            field.onChange(items?.map((item) => item.id) ?? [])
          }
        />
      )}
    />
  );
};

export { ControlledMultiCombobox };
